






import { Component, Prop, Vue } from 'vue-property-decorator'
import FormBase from '@/shared/classes/form/form-base'
import Company from '@/shared/modules/company/company.model'
import { CompanyGetters } from '@/shared/store/company/company.getters'
import Field from '@/shared/classes/form/field'
import { FieldTypes } from '@/shared/components/form/field-types'
import Form from '@/shared/components/form/Form.vue'
import PageHeader from '@/admin/components/PageHeader.vue'
import { GlobalActions } from '@/shared/store/global/global.actions'
import { SnackBarTypes } from '@/shared/helpers/snack-bar.helper'
import __ from '@/shared/helpers/__'

@Component({
  components: { Form, PageHeader },
  methods: { __ }
})
export default class UploadDocumentsDialog extends Vue {
  @Prop() meta: any
  form: FormBase|null = null

  created() {
    const { project, group } = this.meta

    this.form = new FormBase()
      .setEndpoint(`company/${ this.company.slug }/projects/${ project.uuid }/groups/${ group.uuid }/upload`)
      .setFiles(true)
      .setFields([
        new Field()
          .setType(FieldTypes.dropzone)
          .setKey('attachment')
          .setTitle(__('company.components.views.projects.projects-show.upload-documents-dialog.form.attachment')),
        new Field()
          .setType(FieldTypes.textArea)
          .setKey('description')
          .setTitle(__('company.components.views.projects.projects-show.upload-documents-dialog.form.description')),
      ])
      .setOnSuccess(this.onSuccess)
  }

  onSuccess() {
    this.$store.dispatch(GlobalActions.showSnackBar, {
      type: SnackBarTypes.success,
      message: __('company.components.views.projects.projects-show.upload-documents-dialog.form.on-success')
    })

    this.$store.dispatch(GlobalActions.closeDialog)

    this.meta.onSuccess && this.meta.onSuccess()
  }

  get company(): Company {
    return this.$store.getters[CompanyGetters.getCompany]
  }
}
